import React from "react";
import {useTranslation} from "react-i18next";
import Aux from "../../hoc/Auxiliary"

const langSwitcher = (props) => {
    const {t, i18n} = useTranslation();

    function changeLanguage() {
        i18n.changeLanguage(
            t("langSwitcher.alt_language_short").toLowerCase(), (err, t) => {
                if (err) return console.log('something went wrong loading language', err);
                let date = new Date();
                const days = 365;

                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                let expires = "; expires=" + date.toUTCString();
                let domain = document.domain.match(/[^\.]*\.[^.]*$/)[0];
                if (domain !== 'azurewebsites.net') {
                    document.cookie = "i18next=" + i18n.language + expires + ";domain=." + (document.domain.match(/[^\.]*\.[^.]*$/)[0]) + "; path=/";
                }
                else {
                    document.cookie = "i18next=" + i18n.language + expires + "; path=/";
                }
            }
        );
        if (document.body.classList.contains('open-menu')) {
            document.body.classList.remove('open-menu');
        }
    }

    return (
        (props.status == "notlogged")?
            <Aux>
                <a className="nav-link d-flex align-items-center" href="#" role="button" data-toggle="dropdown"
                   aria-haspopup="true"
                   aria-expanded="false">
                    <span className="desktop-only">{t("langSwitcher.current_language_short")}</span>
                    <span className="mobile-only">{t("langSwitcher.current_language_long")}</span>&nbsp;&nbsp;<i
                    className="fas fa-angle-down"></i>
                </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a className="dropdown-item" onClick={() => changeLanguage()} >
                        <span className="desktop-only">  {t("langSwitcher.alt_language_short")}</span>
                        <span className="mobile-only">  {t("langSwitcher.alt_language_long")}</span>
                    </a>
                </div>
            </Aux> : <div className="lang-switcher">
                <a
                    className="desktop-only"
                    onClick={() => changeLanguage()}
                >
                    {t("langSwitcher.alt_language_short")}
                </a>
                <a
                    className="mobile-only"
                    onClick={() => changeLanguage()}
                >
                    {t("langSwitcher.alt_language_long")}
                </a>
            </div>

    );
};

export default langSwitcher;
